<ng-container *transloco="let t; read: 'documents.nlp-output'">
  @if (showHeader) {
    <div class="header">
      <xi-icon icon="feedback" iconSize="large"></xi-icon>

      {{ headerLabel || t('header') }}
    </div>
  }

  @if (sectionFilter?.filterBase) {
    <div class="section-filters-wrapper">
      <span class="group-name kxi-text-large">{{ t('filters') }}</span>
      <div class="section-filters">
        <app-lex-xi-tag
          [text]="sectionFilterLabel"
          type="user"
          [canUserDelete]="true"
          (onClick)="onRemoveSectionFilter()"
        ></app-lex-xi-tag>
      </div>
    </div>
  }
  @for (analyticItem of analyticItems; track analyticItem) {
    <div class="meta-groups-wrapper">
      @if (
        analyticGroupStates[analyticItem] &&
        !analyticGroupStates[analyticItem].hidden &&
        (countItems(analyticItem) > 0 ||
          analyticItem.includes('entities') ||
          analyticItem.includes('topics') ||
          analyticItem.includes('sentimentPolarity'))
      ) {
        <div class="group-name" [attr.data-group-name]="analyticItem">
          <div class="chevron" (click)="onMetaExpand(analyticItem)">
            @if (analyticGroupStates[analyticItem].expanded) {
              <img src="assets/icons/up-line-gray-24-px.svg" alt="" />
            }
            @if (!analyticGroupStates[analyticItem].expanded) {
              <img src="assets/icons/down-line-gray-24-px.svg" alt="" />
            }
          </div>
          <div class="text">
            {{ getSectionHeader(analyticItem) }}
          </div>
          @if (canHighlightAll(analyticItem)) {
            <div class="document-nlp-output__dropdown_icon_button">
              <xi-icon-button
                [icon]="highlightedFeature === analyticItem ? 'visibility_filled' : 'visibility'"
                [buttonSize]="'large'"
                [tooltip]="{ text: t('highlight-all-items') }"
                [hasAnimation]="false"
                (onClick)="highlightAll(analyticItem)"
              ></xi-icon-button>
            </div>
          }
          @if (
            !isReadOnly &&
            !isTestMode &&
            analyticItem.includes('entities') &&
            !options.isDashboardLocked &&
            interactionMode !== 'journey'
          ) {
            <div class="document-nlp-output__dropdown_icon_button">
              <xi-icon-button
                icon="add_circle_filled"
                [buttonSize]="'large'"
                [tooltip]="{ text: t('add-new-entity') }"
                [hasAnimation]="false"
                (onClick)="onAddEntityClicked()"
              ></xi-icon-button>
            </div>
          }
          @if (
            !isReadOnly &&
            !isTestMode &&
            analyticItem.includes('topics') &&
            !options.isDashboardLocked &&
            interactionMode !== 'journey'
          ) {
            <div class="document-nlp-output__dropdown_icon_button">
              <xi-icon-button
                icon="add_circle_filled"
                [buttonSize]="'large'"
                [tooltip]="{ text: t('add-manual-topic') }"
                [hasAnimation]="false"
                (onClick)="onAddTopicClicked()"
              ></xi-icon-button>
            </div>
          }
        </div>
        <div class="meta-list" [ngClass]="{ hidden: !analyticGroupStates[analyticItem].expanded }">
          @if (tableConfig[analyticItem]) {
            <div>
              <table
                #table
                mat-table
                [dataSource]="getTableDataSource(analyticItem)"
                matSort
                matSortDisableClear
                [matSortActive]="tableConfig[analyticItem].sort.field"
                [matSortDirection]="tableConfig[analyticItem].sort.dir"
                (matSortChange)="sortTable($event, table, analyticItem)"
                class="full-width"
              >
                <tr mat-header-row *matHeaderRowDef="tableConfig[analyticItem].columns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: tableConfig[analyticItem].columns"
                  [matTooltip]="rowTooltip"
                ></tr>
                @for (coldef of tableConfig[analyticItem].defs; track coldef) {
                  <ng-container [matColumnDef]="coldef.field">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      [mat-sort-header]="coldef.sort || coldef.field"
                      [disabled]="coldef.sortable === false"
                    >
                      {{ coldef.label }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let item"
                      [class.clickable]="isColumnClickable(analyticItem, item, coldef.field)"
                      (click)="onCellClick(analyticItem, item, coldef)"
                    >
                      <div [class.clicked]="isCellClicked(analyticItem, item, coldef)">
                        @switch (coldef.field) {
                          @case ('sentimentScore') {
                            @if (item.type !== 'model' && item.type !== 'clause_models') {
                              <app-sentiment-display
                                [sentimentScale]="options.sentimentScale"
                                [sentimentDisplay]="options.sentimentDisplay"
                                [sentimentRanges]="options.sentimentRanges.feature"
                                [item]="item"
                                [showTooltip]="this.isTestMode ? false : true"
                                [precision]="1"
                              ></app-sentiment-display>
                            } @else {
                              -
                            }
                          }
                          @case ('strengthScore') {
                            {{
                              item.type !== 'query' && item.strengthScore !== null
                                ? (item.strengthScore | number: '1.2-2')
                                : '-'
                            }}
                          }
                          @case ('modification') {
                            {{ item.isIntensified ? 'intensified' : '' }}
                            {{ item.isIntensified && item.isNegated ? ',' : '' }}
                            {{ item.isNegated ? 'negated' : '' }}
                          }
                          @case ('type') {
                            {{ item.typeLabel }}
                          }
                          @case ('editItem') {
                            @if (
                              !isReadOnly &&
                              item.type !== 'clause_models' &&
                              (!isTestMode || item?.type !== 'named') &&
                              interactionMode !== 'journey'
                            ) {
                              <div class="edit-item-button">
                                <xi-icon-button
                                  icon="edit"
                                  color="CX"
                                  (onClick)="onEditItemClicked(analyticItem, item)"
                                >
                                </xi-icon-button>
                              </div>
                            }
                            @if (
                              isTestMode &&
                              !isReadOnly &&
                              item.type !== 'clause_models' &&
                              item?.type === 'named'
                            ) {
                              <div class="edit-item-button" [id]="item.title">
                                <xi-dropdown
                                  type="icon"
                                  color="CX"
                                  select="none"
                                  [data]="namedEntitiesDropdown"
                                  [internalProps]="{ iconButton: { icon: 'edit' } }"
                                  (onOpenChange)="onEntitiesDropdownOpenChange(item, $event)"
                                  (onValueChange)="onEntitiesDropdownValueChange(item, $event)"
                                ></xi-dropdown>
                              </div>
                            }
                          }
                          @case ('pin') {
                            <xi-icon-button
                              [icon]="item.isPinnedCurrently ? 'pin_filled' : 'pin'"
                              (onClick)="onPinItem(analyticItem, item)"
                            >
                            </xi-icon-button>
                          }
                          @case ('taxonomyPath') {
                            {{ getTaxonomyPath(item) }}
                          }
                          @default {
                            <div *appMiddleEllipsize="item[coldef.field]"></div>
                          }
                        }
                      </div>
                    </td>
                  </ng-container>
                }
              </table>
            </div>
          } @else {
            <span>
              @if (!analyticItem.includes('sentimentPolarity')) {
                {{ listItemsFor(analyticItem, 'title') }}
              } @else {
                <span class="semi-bold"
                  >{{
                    isDocumentLevelSentiment
                      ? t('sentiment-document-level')
                      : t('sentiment-section-level')
                  }}:
                </span>
                <span [ngClass]="sentiment">
                  <strong>
                    {{ sentimentScore | number: '1.1-1' }}
                  </strong>
                  ({{ sentiment }})
                </span>
              }
              @if (
                !isReadOnly &&
                !isTestMode &&
                isDocumentLevelSentiment &&
                analyticItem.includes('sentimentPolarity') &&
                !options.isDashboardLocked
              ) {
                <div class="edit-doc-sentiment">
                  <xi-icon-button icon="edit" (onClick)="onEditSentimentClicked()"></xi-icon-button>
                </div>
              }
            </span>
            @if (isClauseHighlightingEnabled && analyticItem.includes('sentimentPolarity')) {
              <div class="highlight-header">
                {{ t('sentiment-highlight-header') }}
                <span class="sentiment-button">
                  @for (sentimentBtn of sentimentButtons; track sentimentBtn) {
                    <xi-sentiment-button
                      [class.isFocused]="getSentimentToggleValue(sentimentBtn.sentiment)"
                      [isFocused]="getSentimentToggleValue(sentimentBtn.sentiment)"
                      [disabled]="sentimentBtn.disabled"
                      [sentiment]="sentimentBtn.sentiment"
                      (onClick)="sentimentBtn.onClick()"
                    ></xi-sentiment-button>
                  }
                </span>
              </div>
            }
          }
        </div>
      }
    </div>
  }
</ng-container>
